export enum OperatorsEnum {
    Equal = 'eq',
    OR = 'or'
}